import { useCallback, useState } from 'react';

import { countryOptions, countryToCurrency, currencyOptions } from '../dropdownOptions';
import { Option } from '../pages/types';

export function usePromotionCountryCurrency() {
  const [eligibleCountry, setEligibleCountry] = useState<Option | undefined>();
  const [currency, setCurrency] = useState<Option | undefined>();

  const handleCountryChange = useCallback((option: Option) => {
    setEligibleCountry(option);
    const currencyOption = currencyOptions.find((c) => c.value === countryToCurrency[option.value]);
    setCurrency(currencyOption);
  }, []);

  const handleCurrencyChange = useCallback((option: Option) => {
    setCurrency(option);
    const countryOption = countryOptions.find((c) => countryToCurrency[c.value] === option.value);
    setEligibleCountry(countryOption);
  }, []);

  return {
    eligibleCountry,
    currency,
    handleCountryChange,
    handleCurrencyChange,
  };
}
